import { createSelector } from '@ngrx/store';
import { getHistoryOrderByOrderId } from '../getHistoryOrderByOrderId';
import { OnlineOrders } from '@shared/core/utils';

export const getHistoryOrderTypeGroup = (orderId: number) =>
    createSelector(
        getHistoryOrderByOrderId(orderId),
        (order) => OnlineOrders.detectOrderCollectionTypeGroup(order?.data)
    );
